export default "//yastatic.net/s3/distribution/pythia/frontend/_/7c586edd549eeb7dfbe40c939fa2e665.svg";